import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import LoadingWrapper from 'components/hoc/LoadingWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import pristupPlatnost from 'services/akcionar/pristupPlatnost';

import routePathEnum from 'enums/routePathEnum';

interface RegistraceMajetkuProps {}

const RegistraceMajetku: React.FC<RegistraceMajetkuProps> = () => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { tokenURL } = useParams<{ tokenURL: string }>();
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    // Pri mountu se zkontroluje hash v url
    useEffect(() => {
        if (!tokenURL) return;
        setLoading(val => !val);
        pristupPlatnost(tokenURL)
            .then(() => {
                navigateWorkaround(`${routePathEnum.LOGIN}/${tokenURL}`);
            })
            .catch((err: any) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(val => !val));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenURL]);

    return (
        <AuthWrapper>
            <LoadingWrapper loading={loading}>
                <Row>
                    {errStatus === 401 && <Title level={3} text="CHYBA_UCET_JIZ_AKTIVOVAN" />}
                    {errStatus === 400 && <Title level={3} text="CHYBA_NEPLATNY_ODKAZ" />}
                </Row>
                <Row>
                    <Col>
                        <AnchorComponent link={true} to={routePathEnum.LOGIN_ROZCESTNIK}>
                            <ButtonComponent buttontext="ZPET" id="registraceMajetkyZpetBtn" type="default" />
                        </AnchorComponent>
                    </Col>
                </Row>
            </LoadingWrapper>
        </AuthWrapper>
    );
};

export default RegistraceMajetku;
